import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const InfoText = styled.div`
  max-width: none;
  width: auto;
  overflow-wrap: anywhere;
  color: ${colors.emperor};
  ${media.mediumHigh`
    max-width: unset;
    width: unset;
  `}

  // adjust the default stylings for <p> / <ol> / <ul> for the inserted html
  & ul {
    list-style-type: disc;
  }
  & ol {
    list-style-type: decimal;
  }
  & ul,
  ol,
  p {
    margin: 0 0 0.5rem !important;
    padding: 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
  & ul,
  ol {
    margin-left: 2rem !important;
  }
  line-height: 1.5;
`;

export const NoTicketsContainer = styled.div`
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  width: 100%;
  margin: auto;

  padding-bottom: 0.75rem;

  // styling for the links inside the translated string, inserted as innerhtml
  & a {
    color: ${colors.pacificBlue};
    text-decoration: none;
  }
`;
